import { lazy } from 'react';
import type { AppManifest } from '@/apps/types';

/**
 * The visualisation window — Winamp's plugin slot, in the MilkDrop and Geiss
 * tradition: a GPU feedback loop steered by whatever the player is playing.
 *
 * Its own window rather than a mode inside Winamp, because that is what these
 * were: you left the player small in a corner and gave the visualiser the
 * whole screen. It takes its audio from the analyser bus (`lib/analyser.ts`),
 * so it follows the player without either app knowing about the other.
 *
 * A singleton — two feedback loops on one GPU for no benefit — and resizable
 * and maximizable, because the entire point is to make it big.
 */
export const visualizerApp: AppManifest = {
  id: 'visualizer',
  name: 'Visualization',
  icon: '/assets/icons/visualizer.svg',
  component: lazy(() => import('./Visualizer')),

  // 4:3, as the plugins that inspired it were.
  defaultSize: { w: 640, h: 500 },
  minSize: { w: 320, h: 240 },
  resizable: true,
  maximizable: true,
  singleton: true,

  group: 'Accessories',
  titleFor: () => 'Visualization',
};
